import { render, staticRenderFns } from "./BaseArticles.vue?vue&type=template&id=3e25e3fa&scoped=true&"
import script from "./BaseArticles.vue?vue&type=script&lang=js&"
export * from "./BaseArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e25e3fa",
  null
  
)

export default component.exports